import ListingWizardPage from './ListingWizardPage';

export default ListingWizardPage;
